/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropruleslabel2Inputs */

const en_dropruleslabel2 = /** @type {(inputs: Dropruleslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eligibility rules`)
};

const de_dropruleslabel2 = /** @type {(inputs: Dropruleslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahmebedingungen`)
};

/**
* | output |
* | --- |
* | "Eligibility rules" |
*
* @param {Dropruleslabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropruleslabel2 = /** @type {((inputs?: Dropruleslabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropruleslabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropruleslabel2(inputs)
	return de_dropruleslabel2(inputs)
});
export { dropruleslabel2 as "dropRulesLabel" }